/*************************************
	onDOMload
	v1.1
	last revision: 03.31.2005
	aaron@zelph.com
	get more info: http://www.zelph.com/releases/ondomload/
	
	zelph_ prefix is just so function names don't interfere with potentially similarly named functions.

	Vars passed to the function
	dtw = Do To What -  the id/class/tagname that the code should be run on
	ctr = Code To Run -  is the actual code to run on the element/id.  use "theTarget" to reference the element you want to work with in the code you pass
	
	Other vars used in the script
	ndc = Number Done Count - Array that will hold the number that have been done for each request. Uses assoicative array,
	kg = Keep Going - as long as this is true the loop continues. Stops after "onload" event is fired
	es = ElementS (e and s) - tht elements returned by the getElementsBySelector
	nes = Number ElementS - the number of elements returned above
	coc = Copy Of Code - copy of the code we are running, so it can be run one last time when the onload fires to stop the loops
*************************************/
d = document;
ndc = new Array();
coc = new Array();
kg = true;
function zelph_onDOMload(dtw,ctr){
	es = zelph_getElementsBySelector(dtw); // get all elements that match what we are looking for
//	alert(es.length);
	if(ndc[dtw] == null){
		ndc[dtw] = 0; // initialize the number we have done for this tag type
		coc[coc.length] = "zelph_onDOMload('" + dtw + "', '" + ctr + "')"; // copy off the code
	}
	if(es.length > ndc[dtw]){ // if available elments are greater then the number of elements already done, then lets do them
		nes = es.length;
		for(var x=ndc[dtw]; x<nes; x++){ // loop through all elements that have not been done yet
			// do what we need to do
			theTarget = es[x];
			eval(ctr);
		}
		ndc[dtw] = nes;
	}
	
	if(kg == true){
		// play it again sam
		setTimeout("zelph_onDOMload('" + dtw + "', '" + ctr + "')", 100);
	}
	return true;
}

// taken from http://pro.html.it/esempio/nifty/niftyCodice.html
// modified to return false in a few situations since that wasn't an option in the original script
function zelph_getElementsBySelector(selector){
	var i;
	var s=[];
	var selid="";
	var selclass="";
	var tag=selector;
	var objlist=[];
	if(selector.indexOf(" ")>0){  //descendant selector like "tag#id tag"
		s=selector.split(" ");
		var fs=s[0].split("#");
		if(fs.length==1) return(objlist);
		if(d.getElementById(fs[1])){
			return(d.getElementById(fs[1]).getElementsByTagName(s[1]));
		}
		return false;
	}
	if(selector.indexOf("#")>0){ //id selector like "tag#id"
		s=selector.split("#");
		tag=s[0];
		selid=s[1];
	}
	if(selid!=""){
		if(d.getElementById(selid)){
			objlist.push(d.getElementById(selid));
			return(objlist);
		}
		return false;
	}
	if(selector.indexOf(".")>0){  //class selector like "tag.class"
		s=selector.split(".");
		tag=s[0];
		selclass=s[1];
	}
	var v=d.getElementsByTagName(tag);  // tag selector like "tag"
	if(selclass=="")return(v);
	for(i=0;i<v.length;i++){
		curClass = " "+v[i].className+" ";
		if(curClass.indexOf(" "+selclass+" ") != "-1"){
			objlist.push(v[i]);
		}
	}
	return(objlist);
}

function zelph_stopIt(){
	kg = ""; // stop the flash loop
	for(x=0; x<coc.length; x++){ // one last check of each script
		eval(coc[x]);
	}
}

// not needed if you already have your own onload function or if you just want to use onload.  Just call the "zelph_stopIt" function however you want to.

function zelph_addLoadEvent(func) { // allows multiple window.onload's Thanks to Simon - http://simon.incutio.com/archive/2004/05/26/addLoadEvent
  var oldonload = window.onload;
  if (typeof window.onload != 'function') {
    window.onload = func;
  } else {
    window.onload = function() {
      oldonload();
      func();
    }
  }
}

zelph_addLoadEvent(zelph_stopIt);